import { Skeleton } from "@/components/ui/skeleton";

export default function QuoteSummarySkeleton() {
  return (
    <div className="md:space-y-6 md:py-6  py-2">
      <Skeleton className="h-8 md:w-1/2 w-3/4 mb-6" />

      <div className="grid grid-cols-1 md:grid-cols-9 md:gap-5 md:p-6 ">
        <div className="md:col-span-2">
          <Skeleton className="h-[680px] w-full rounded-xl" />
        </div>

        <div className="col-span-4 space-y-5">
          <Skeleton className="h-[627px] w-full rounded-xl" />
          <Skeleton className="h-10 w-1/2 mx-auto" />
          {[...Array(2)].map((_, i) => (
            <Skeleton key={i} className="h-5 w-full" />
          ))}
        </div>
        <div className="col-span-3 space-y-4">
          <Skeleton className="h-[640px] w-full rounded-xl" />
          <Skeleton className="h-10 w-1/2 ml-auto" />
        </div>
      </div>
    </div>
  );
}
